import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ReleaseNotesEndpointResponse } from 'elements-sdk'
import { APIService } from 'api/module'
import type { ReleaseNotesService } from '../services/releaseNotes.service'

import './releaseNotesModal.global.scss'

@Component({
  selector: 'release-notes-modal',
  templateUrl: './releaseNotesModal.component.pug',
  styleUrls: ['./releaseNotesModal.component.scss'],
})
export class ReleaseNotesModalComponent {
  @Input() content: string
  releaseNotes: ReleaseNotesService
  expanded = {}
  notes: ReleaseNotesEndpointResponse[] = []

  constructor (
    public modalInstance: NgbActiveModal,
    private api: APIService,
  ) { }

  async ngOnInit () {
    this.notes = await this.api.main.getReleaseNotes()
    for (const note of this.notes) {
      this.expanded[note.version] = this.releaseNotes.featureIsNew(note.version)
    }
    this.expanded[this.notes[0].version] = true
  }
}
